import React, { useEffect, useState } from 'react';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import { toast } from 'react-toastify';
import { formatDate } from '../../utils/FormatDateTime';
import { getSatelliteAnalytics, getSatelliteFarms, patchSatelliteFarm } from '../../services/satelliteFarm';
import SearchBar from '../../components/searchBar/SearchBar';
import Dropdown from '../../components/inputFields/DropDown';
import { BiRefresh } from 'react-icons/bi';
import ShowModal from '../../utils/ShowModal';
import SatelliteEnquiryDetails from './SatelliteEnquiryDetails';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import { useSearchParams } from 'react-router-dom';
import {
    FaUsers, FaUserTie, FaStore, FaTractor, FaSatellite,
    FaBoxes, FaSeedling, FaMobileAlt, FaChartBar,
    FaIndustry, FaTags, FaClipboardList, FaMapMarkedAlt,
    FaClock, FaSearchDollar, FaBox
} from 'react-icons/fa';
import Tab from '../../components/tabs/Tab';
import { confirmDialog } from '../../utils/confirmDialog';
import { getUserId } from '../../helpers/local_storage_helpers';
import { BiCopy } from 'react-icons/bi';
import { FiEdit2 } from 'react-icons/fi';

function SatelliteEnquiry() {
    const [searchParams, setSearchParams] = useSearchParams();

    const [cardData, setCardData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [subTab, setSubTab] = useState("pending");
    const [filterSubsEnded, setFilterSubsEnded] = useState(false);

    const [modalIsOpen, setIsOpen] = useState(false);
    const [openingItem, setOpeningItem] = useState({});


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "S.No./ID", key: "index" },
        { label: "Date", key: "created_at" },
        { label: "User", key: "user_name" },
        { label: "Farm", key: "farm", width: "130px" },
        { label: "Crop", key: "crop", width: "100px" },
        { label: "Payment", key: "payment" },
        { label: "Subscription", key: "subscription_start_date" },
        { label: "Note", key: "sales_team_notes", width: "300px" },
        { label: "Approval", key: "sales_team_approval" },
    ];

    const pageSize = 50;

    // Helper function to update URL parameters
    const updateURLParams = (updates) => {
        const newParams = new URLSearchParams(searchParams);

        Object.entries(updates).forEach(([key, value]) => {
            if (value === null || value === undefined || value === "") {
                newParams.delete(key);
            } else {
                newParams.set(key, value);
            }
        });

        setSearchParams(newParams, { replace: true });
    };

    // Helper function to get URL parameters
    const getURLParams = () => {
        const params = {};

        // Get search text
        params.search = searchParams.get('search') || '';

        // Get sub tab
        params.subTab = searchParams.get('subTab') || 'pending';



        // Get current page
        params.page = parseInt(searchParams.get('page')) || 1;

        return params;
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        updateURLParams({ page });

        // Fetch data with the new page
        const urlParams = getURLParams();
        fetchData(urlParams, page);
    };

    const handleSearch = (query) => {
        setSearchText(query);
        updateURLParams({ search: query, page: 1 });
        const urlParams = getURLParams();
        fetchData({ ...urlParams, search: query }, 1);
    };



    const handleSubTabChange = (value) => {
        setSubTab(value);
        updateURLParams({ subTab: value, page: 1 });
        const urlParams = getURLParams();
        fetchData({ ...urlParams, subTab: value }, 1);
    };

    const resetFilters = () => {
        setSearchText("");
        setSubTab("pending");
        setCurrentPage(1);

        // Clear all URL parameters
        setSearchParams({}, { replace: true });
        fetchData({ search: "", subTab: "pending" }, 1);
    };

    const openModal = (item) => {
        setOpeningItem(item);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setOpeningItem({});
    };

    const fetchData = async (params, page) => {
        setLoading(true);
        try {
            const urlParams = params || getURLParams();
            const currentPageNum = page || urlParams.page;

            let query = `search=${urlParams.search}&page=${currentPageNum}`;

            query += `&sales_team_approval=${urlParams.subTab}`;

            let res = await getSatelliteFarms(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAnalytics = async () => {
        try {
            let res = await getSatelliteAnalytics();
            if (res.status === 200) {
                const data = res.data;
                setCardData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleEditNote = async (item) => {
        const result = await confirmDialog(
            "Update Sales Team Notes",
            "Edit Note",
            {
                showInput: true,
                inputPlaceholder: "Enter notes...",
                confirmText: "Update",
                inputValue: item.sales_team_notes || ""
            }
        );

        if (result !== false) {
            setLoading(true);
            try {
                const response = await patchSatelliteFarm(item.id, {
                    sales_team_notes: result.notes,
                    sales_team: getUserId()
                });
                if (response.status === 200) {
                    toast.success("Note updated successfully");
                    const urlParams = getURLParams();
                    fetchData(urlParams);
                } else {
                    toast.error("Unable to update note");
                }
            } catch (error) {
                console.error("Error updating note:", error);
                toast.error("An error occurred while updating the note");
            } finally {
                setLoading(false);
            }
        }
    };

    const checkFarmApproval = async (id, newStatus, no_of_approved_farms = 0) => {
        let notes = "";
        let freeTrial = true;
        if (newStatus === "approved") {
            const result = await confirmDialog(
                "Please provide any notes for this approval.",
                "Approve Farm",
                {
                    showInput: true,
                    inputPlaceholder: "Enter approval notes...",
                    showToggle: true,
                    toggleTitle: "Are you providing free trial?",
                    toggleValue: true,
                    confirmText: "Approve",
                    type: "success"
                }
            );

            if (result === false) {
                // User cancelled or closed the modal
                const urlParams = getURLParams();
                fetchData(urlParams);
                return;
            }
            notes = result.notes;
            freeTrial = result.toggle;
        } else if (newStatus === "rejected") {
            const result = await confirmDialog(
                "Please provide a reason for rejection.",
                "Reject Farm",
                {
                    showInput: true,
                    inputPlaceholder: "Enter rejection reason...",
                    confirmText: "Reject",
                    type: "danger"
                }
            );

            if (result === false) {
                const urlParams = getURLParams();
                fetchData(urlParams);
                return;
            }
            notes = result.notes;
        }

        if (no_of_approved_farms > 0 && newStatus === "approved") {
            const confirm = await confirmDialog(
                "More than 1 farm is approved for this user. Are you sure you want to approve this farm?",
                "Confirm Farm Approval",
                {
                    type: "warning",
                    confirmText: "Approve",
                    cancelText: "Cancel"
                }
            );

            if (confirm) {
                patchDropdownData(id, newStatus, notes, freeTrial);
            } else {
                const urlParams = getURLParams();
                fetchData(urlParams);
            }
        } else {
            patchDropdownData(id, newStatus, notes, freeTrial);
        }
    };

    const patchDropdownData = async (id, newStatus, notes = "", freeTrial = false) => {
        setLoading(true);
        try {
            const dataToSend = {
                sales_team_approval: newStatus,
                sales_team_notes: notes,
                sales_team: getUserId(),
            };
            if (newStatus === "approved") {
                dataToSend.is_free = freeTrial;
            }
            let res = await patchSatelliteFarm(id, dataToSend);
            if (res.status === 200) {
                const urlParams = getURLParams();
                fetchData(urlParams);
            } else {
                toast.error("Unable to Update status");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    // Initialize state from URL parameters and fetch data once on mount
    useEffect(() => {
        const urlParams = getURLParams();

        setSearchText(urlParams.search);
        setSubTab(urlParams.subTab);
        setFilterSubsEnded(urlParams.subsEnded);
        setCurrentPage(urlParams.page);

        // Fetch data and analytics on mount
        fetchData(urlParams);
        fetchAnalytics();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array - only run on mount

    const getStatIcon = (title) => {
        const iconMap = {
            // Existing mappings
            "Total Users": FaUsers,
            "Total Staff Users": FaUserTie,
            "Total Dukaan Users": FaStore,
            "Total Farms": FaTractor,
            "Total Satellite Records": FaSatellite,
            "Total Commodities": FaBoxes,
            "Total Practice Commodities": FaSeedling,
            "Total FPO": FaUsers,
            "Total User Devices": FaMobileAlt,
            "Total Shops": FaStore,
            "Total Manufacturers": FaIndustry,
            "Total Categories": FaTags,
            "Total Products": FaBoxes,
            "Total Subscription": FaClipboardList,
            "Total Plans": FaBox,
            "Pending Subscription": FaClock,
            "Pending Review": FaSearchDollar,
            "Total Area(In Hect.)": FaMapMarkedAlt
        };

        const IconComponent = iconMap[title] || FaChartBar;
        return IconComponent;
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Satellite Enquiries' },
        ]} />

        <div className="py-3">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-2">
                <StyledHeadingText text={"Summary"} />
                <div className="w-full sm:w-72">
                    <SearchBar
                        placeholder="Search by Number / Name"
                        onSearch={handleSearch}
                        value={searchText}
                    />
                </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.value} key={index} icon={getStatIcon(card.title)} />
                ))}
            </div>
        </div>
        {(searchText.length !== 0 || subTab !== "pending") && (
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 mb-4">
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 flex-1 w-full lg:w-auto">
                        {/* Search bar moved to top */}
                    </div>

                    {/* Active Filters Summary & Reset */}
                    <div className="flex items-center gap-3">
                        <div className="flex items-center gap-2 flex-wrap">
                            {searchText && (
                                <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                                    Search: {searchText.substring(0, 15)}{searchText.length > 15 ? '...' : ''}
                                </span>
                            )}

                        </div>
                        <button
                            onClick={resetFilters}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-primary hover:bg-primary/5 rounded-lg transition-colors"
                            title="Reset all filters"
                        >
                            <BiRefresh size={18} />
                            <span className="hidden sm:inline">Reset</span>
                        </button>
                    </div>
                </div>
            </div>
        )}
        <div className="my-2 space-y-2">
            <Tab tabsList={[
                { name: "Pending", id: "pending" },
                { name: "Approved", id: "approved" },
                { name: "Rejected", id: "rejected" },
            ]} onClick={handleSubTabChange} activeTab={subTab} />
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                index: (
                                    <div className="flex flex-col gap-1 items-center">
                                        <div
                                            onClick={() => openModal(item)}
                                            className="cursor-pointer font-semibold text-sm text-gray-700"
                                        >
                                            {index + 1}.
                                        </div>
                                        <div className="flex items-center gap-1 group cursor-pointer" onClick={() => {
                                            navigator.clipboard.writeText(item.id);
                                            toast.success("ID copied!");
                                        }}>
                                            <BiCopy className="text-gray-400 group-hover:text-primary" size={14} />
                                        </div>
                                    </div>
                                ),
                                created_at: (
                                    <div onClick={() => openModal(item)} className="cursor-pointer">
                                        <p className="text-sm text-gray-700">{item.created_at ? formatDate(item.created_at).split(',')[0] : "-"}</p>
                                    </div>
                                ),
                                user_name: (
                                    <div onClick={() => openModal(item)} className="cursor-pointer">
                                        <p className="font-medium text-sm text-gray-800 hover:text-primary transition-colors">{item.user_name}</p>
                                        <p className="text-xs text-gray-500 font-mono mt-0.5">{item.user_phone_number}</p>
                                    </div>
                                ),
                                farm: (
                                    <div onClick={() => openModal(item)} className='cursor-pointer group'>
                                        <p className='font-medium text-sm text-gray-700 group-hover:text-primary transition-colors'>
                                            {item.farm.name}
                                        </p>
                                        <p className='text-xs text-gray-500 mt-0.5'>
                                            {item.farm.size} {item.farm.area_unit}
                                        </p>
                                    </div>
                                ),
                                crop: (
                                    <div onClick={() => openModal(item)} className="cursor-pointer">
                                        <p className="text-sm text-gray-700">{item.farm.crop ? item.farm.crop.name : "-"}</p>
                                    </div>
                                ),
                                payment: (
                                    <div onClick={() => openModal(item)} className="flex flex-col gap-1 cursor-pointer">
                                        <span className='font-medium text-sm text-gray-800'>₹{item.paid_amount}</span>
                                        <span className={`text-[10px] font-bold uppercase ${item.payment_status === "Success" ? "text-green-600" : "text-red-600"}`}>
                                            {item.payment_status || "-"}
                                        </span>
                                    </div>
                                ),
                                subscription_start_date: (
                                    <div onClick={() => openModal(item)} className="cursor-pointer">
                                        <p className="text-xs text-gray-500">Start: {formatDate(item.subscription_start_date).split(',')[0]}</p>
                                        <p className={`text-xs font-medium mt-0.5 ${(new Date(item.subscription_end_date) < new Date() && item.farm_status === "correct") ? 'text-red-600' : 'text-gray-700'}`}>
                                            End: {formatDate(item.subscription_end_date).split(',')[0]}
                                        </p>
                                    </div>
                                ),
                                sales_team_notes: (
                                    <div className="flex items-center gap-2 group cursor-pointer" onClick={() => handleEditNote(item)}>
                                        <p className="text-sm text-gray-600 max-w-[280px] truncate" title={item.sales_team_notes}>
                                            {item.sales_team_notes || "-"}
                                        </p>
                                        <FiEdit2 className="text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity hover:text-primary" size={12} />
                                    </div>
                                ),
                                sales_team_approval: (
                                    <div className="min-w-32">
                                        <Dropdown
                                            label=''
                                            onChange={(value) => { checkFarmApproval(item.id, value, item.no_of_approved_farms); }}
                                            value={item.sales_team_approval}
                                            placeholder={item.sales_team_approval || "Choose"}
                                            options={[
                                                { label: "Pending", value: "pending" },
                                                { label: "Approved", value: "approved" },
                                                { label: "Rejected", value: "rejected" },
                                            ]}
                                        />
                                    </div>
                                ),
                                rowBgColor: (new Date(item.subscription_end_date) < new Date()) && item.farm_status === "correct"
                                    ? 'bg-red-50 hover:bg-red-100'
                                    : 'bg-white hover:bg-gray-50',
                            }))}
                    />
                </div >}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                />
                : <></>
        }
        <ShowModal
            contentLabel={"Farm Details alert"}
            isOpen={modalIsOpen}
            modalWidth="80%"
            isSidebar={true}
            onRequestClose={closeModal}
            componentToPass={<SatelliteEnquiryDetails item={openingItem} onAnyChange={() => {
                const urlParams = getURLParams();
                fetchData(urlParams);
            }} />}
        />
    </>);
}

export default SatelliteEnquiry;
